import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Download, FileText, ScrollText, Award, FileArchive, Search } from "lucide-react";

const TABS = [
  { key: "policy",      label: "Policies",      icon: ScrollText },
  { key: "acts",        label: "Acts & Rules",  icon: FileArchive },
  { key: "circulars",   label: "Circulars",     icon: FileText },
  { key: "recruitment", label: "Recruitment",   icon: Award },
];

const DATA = {
  policy: [
    ["Punjab Solar Policy 2026", "PDF · 1.2 MB", "2 Jan 2026"],
    ["EV Policy Punjab 2026-2030", "PDF · 890 KB", "18 Dec 2025"],
    ["Renewable Energy Purchase Obligation", "PDF · 640 KB", "12 Nov 2025"],
    ["Biogas Programme Policy", "PDF · 520 KB", "5 Oct 2025"],
  ],
  acts: [
    ["Punjab Renewable Energy Act 2018", "PDF · 1.8 MB", "-"],
    ["Energy Conservation Building Code (ECBC)", "PDF · 2.1 MB", "-"],
    ["Electricity Act 2003 (excerpts)", "PDF · 780 KB", "-"],
  ],
  circulars: [
    ["Net Metering revised procedure 2026", "PDF · 280 KB", "8 Jan 2026"],
    ["CBG empanelment window extension", "PDF · 210 KB", "22 Dec 2025"],
    ["Solar rooftop subsidy revision", "PDF · 340 KB", "10 Dec 2025"],
    ["Site inspection SOP v3.0", "PDF · 500 KB", "1 Dec 2025"],
  ],
  recruitment: [
    ["Assistant Engineer (Solar) – 8 posts", "PDF · 420 KB", "Apply by 30 Jan 2026"],
    ["Junior Officer (Finance) – 4 posts", "PDF · 380 KB", "Apply by 15 Feb 2026"],
    ["Field Officer (Biogas) – 12 posts", "PDF · 300 KB", "Apply by 20 Feb 2026"],
  ],
};

export default function DownloadsPage() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "policy";
  const [q, setQ] = useState("");
  const items = (DATA[tab] || []).filter(([t]) => t.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="container-x py-12">
      <div className="label-tiny text-[hsl(var(--primary))]">Downloads</div>
      <h1 className="mt-1 text-3xl lg:text-5xl font-heading font-bold">Documents & Publications</h1>
      <div className="mt-6 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setSp({ tab: t.key })} className={`px-4 py-2 rounded-full text-sm border inline-flex items-center gap-2 ${tab === t.key ? "bg-[hsl(var(--primary))] text-white border-transparent" : "border-border hover:bg-muted"}`}>
            <t.icon className="h-4 w-4"/>{t.label}
          </button>
        ))}
      </div>
      <div className="mt-6 max-w-md flex items-center gap-2 rounded-full border border-border bg-muted/40 px-3 py-1.5">
        <Search className="h-4 w-4 opacity-60"/>
        <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Search documents…" className="w-full bg-transparent outline-none text-sm"/>
      </div>
      <div className="mt-6 rounded-xl border border-border overflow-hidden">
        <table className="w-full">
          <thead>
            <tr>
              <th className="table-th">Document</th>
              <th className="table-th">Size</th>
              <th className="table-th">Date</th>
              <th className="table-th text-right"></th>
            </tr>
          </thead>
          <tbody>
            {items.map(([title, size, date], i)=>(
              <tr key={i} className="border-t border-border">
                <td className="table-cell font-medium">{title}</td>
                <td className="table-cell text-muted-foreground">{size}</td>
                <td className="table-cell text-muted-foreground">{date}</td>
                <td className="table-cell text-right"><button className="btn-outline text-xs"><Download className="h-3.5 w-3.5"/>Download</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
